<template>
  <div>
    <el-carousel
      ref="carousel"
      class="content"
      arrow="never"
      indicator-position="none"
      :autoplay="autop"
    >
      <el-carousel-item class="item">
        <vxe-grid v-bind="gridOptions" resizable ref="table"> </vxe-grid>
        <el-row :gutter="20" style="margin-top:15px">
          <el-col :span="6" :offset="18"
            ><el-button type="primary" size="small" @click="exportData">生成计划模板</el-button
            ><el-button size="small" @click="next">{{$t('message.button.next')}}</el-button></el-col
          >
        </el-row>
      </el-carousel-item>
      <el-carousel-item>
          <div class="model" v-loading="loading">
            <el-upload
              class="upload-demo"
              action=""
              :show-file-list="false"
              :before-upload="importFile"
            >
              <span style="display: inline-blcok"
                >{{ $t("message.title.fileImport") }}:</span
              >
              <el-button size="small" type="primary" style="margin-left: 5px">{{
                $t("message.button.toImport")
              }}</el-button>
              <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            </el-upload>
          </div>

          <el-row >
            <el-col :span="6" :offset="16">
              <el-button size="small" @click="cancel">{{
                $t("message.button.cancel")
              }}</el-button>
            </el-col>
          </el-row>
      </el-carousel-item>
      <el-carousel-item>
        <div class="model">
          <ul style="
              position: relative;
              overflow: hidden;
              overflow: hidden;
              list-style: none;
              width: 100%;
              margin-top: 50px;
            ">
            <li v-for="item in fileInfo" class="file-info" :key="item.id">
              <div class="table-list">
                <span class="list-key-1">{{ item.name }}</span>
                <span style="display: inline-block; margin: 0 6px">:</span>
                <span class="list-val" :title="item.val">{{
                  item.val
                }}</span>
              </div>
            </li>
          </ul>
        </div>
        <el-row>
          <el-col :span="6" :offset="16">
            <el-button size="small" @click="done">{{$t('message.title.finish')}}</el-button>
          </el-col>
        </el-row>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import axios from 'axios';
import NProgress from "nprogress"; // 引入nprogress插件
import "nprogress/nprogress.css";
import XLSX from "xlsx";
import FileSaver from "file-saver";
export default {
  data() {
    return {
      value: "",
      active: 0,
      autop: false,
      loading:false,

      gridOptions: {
        border: true,
        resizable: true,
        showOverflow: true,
        stripe: true,
        height: 360,
        align: "left",
        highlightHoverRow: true,
        columns: [
          {
            title: "名称",
            field: "1054001",
            minWidth: "140",
          },
          {
            title: "编号",
            field: "projectNumber",
            minWidth: "140",
          },
          {
            title: "记录",
            field: "1000003",
            minWidth: "140",
          },
          {
            title: "备注",
            field: "1000004",
            minWidth: "140",
          },
        ],
        data: [],
      },

      fileInfo:[],
    };
  },
  props: ["tableData"],
  methods: {
    getData() {
      this.gridOptions.data = this.tableData;
    },
    next() {
      console.log(this.value);
      this.$refs.carousel.next();
      this.active++;
    },
    cancel() {
      this.$refs.carousel.prev();
      this.active--;
    },

    exportData() {
      NProgress.start();
      // 对数据预处理
      const column = this.$refs.table.getColumns();
      const columnTitle = column.map((i) => i.title);
      const columnId = column.map((i) => i.property);
      let data = [];
      data.push(columnTitle);

      this.gridOptions.data.map((i) => {
        let n = [];
        columnId.map((j) => {
          if (j == '1054001' || j == 'projectNumber') {
            n.push(i[j]);
          }
        });
        data.push(n);
      });
      console.log(data);
      // 转换数据
      let book = XLSX.utils.book_new();
      let sheet = XLSX.utils.json_to_sheet(data, { skipHeader: true });
      XLSX.utils.book_append_sheet(book, sheet);
      let wbout = XLSX.write(book, {
        bookType: "xlsx",
        bookSST: false,
        type: "binary",
      });
      let blob = new Blob([this.toBuffer(wbout)], {
        type: "application/octet-stream",
      });

      console.log(data);
      let fileName = data[1][0] + '.xlsx'
      // 保存导出
      FileSaver.saveAs(blob, fileName);
      NProgress.done();
      this.next();
    },
    importFile(file) {
      console.log(file);
      let obj_name = {};
      obj_name.name = "文件名";
      obj_name.val = file["name"];
      let obj_time = {};
      obj_time.name = "上传时间";
      obj_time.val = this.formatDate(file["lastModified"]);
      let arr = [obj_name, obj_time];

      let fd = new FormData();
      // console.log(fd);
      fd.append("file", file);

      fd.append("id", this.$store.state.objectId.id);
      fd.append("classId", this.$store.state.objectId.classId);
      fd.append("subClassId", this.$store.state.objectId.subClassId,);
      this.loading = true;
      // fd.append("changeId", 0);
      // fd.append("changeClassId", 0);
      // fd.append("changeSubClassId", 0);
      // console.log(fd);
      // console.log(this.isGenerateCodeNumber);

      // let url = this.urlList.filter((i) => {
      //   return i.baseId == this.value[0];
      // })[0].url;
      // console.log(url);
      axios.post('/ppm/taskRecord/importTaskRecords', fd).then((res) => {
        console.log(res);
        if (res.status == 200) {
          this.loading = false;
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            let m = res.data.object;
            this.fileInfo = Object.keys(m).map((i, e) => {
              return {
                name: i,
                val: Object.values(m)[e],
              };
            });
            // console.log(this.fileInfo);
            this.fileInfo = [...arr,...this.fileInfo]
            this.next();
          }
          else {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        }
        
      });
    },
    done() {
      this.$emit('close')
    },
    formatDate(date) {
      var date = new Date(date);
      var YY = date.getFullYear() + "-";
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    
  },
  mounted() {
    console.log(this.tableData);
    this.getData();
  },
};
</script>

<style></style>
<style scoped>
.model {
  margin-top: 25px;
  margin-left: -120px;
  text-align: center;
  height: 240px;
  padding-top: 45px;
}
</style>
